export var divider = {
  keyCommand: 'divider'
};